import { getData } from "country-list";
import {
  ICourseBackEndViewModel,
  IStep1,
  IStep2,
  IStep3,
  IStep4,
} from "../types";
import { LANGUAGES } from "../constants";
import { COMMISSION_TYPES, getDurationUnits } from "../../../constants";
import { separateRequiredDocs } from "../../academic/modals/helpers/helperFunctions";
import { currencies } from "../../../utils/const/currencies";

const countries = getData();

export function parseToEditCourseInitialData(
  backEndData: ICourseBackEndViewModel,
  schoolId: string,
) {
  const step1: IStep1 = {
    language: LANGUAGES.find((l) => l.id === backEndData.language)!,
    category: backEndData.category,
    courseType: backEndData.courseType.toString(),
    minAge: backEndData.minAge!.toString(),
    branches: backEndData.branches.map((b) => b.branchId),
    branchesWithAppCount: backEndData.branches.reduce((acc, branch) => {
      acc[branch.branchId] = branch;
      return acc;
    }, {}),
  };

  if (backEndData.maxAge) {
    step1.maxAge = backEndData.maxAge.toString();
  }

  //-----------------Step2---------------------------
  const { requiredDocuments, additionalDocuments } = separateRequiredDocs(
    backEndData.requiredDocs,
  );

  const step2: IStep2 = {
    requiredDocs: requiredDocuments,
    additionalDocuments: additionalDocuments,

    housingTypes: backEndData.housingTypes,
    durationUnit: getDurationUnits().find(
      (d) => d.id === backEndData.durationUnit,
    )!,
    durationAmount: backEndData.durationAmount.toString(),
    restrictedCountries: backEndData.restrictedCountries.map((country) => ({
      code: country,
      name: countries.find((c) => c.code === country)!.name,
    })),
    applicationForms: backEndData.applicationForms.map((a) => ({
      id: a.fileId,
      name: a.name,
      size: a.size,
      preview: a.path,
    })),
  };

  if (backEndData.applicationLink) {
    step2.applicationLink = backEndData.applicationLink;
  }

  //-----------------Step3---------------------------
  const currency = currencies.find(
    (currency) => currency.id === backEndData.currency,
  );

  const addedOtherFees = backEndData.otherFees.map((fee) => ({
    name: fee.name,
    amount: fee.amount.toString(),
  }));

  const step3: IStep3 = {
    price: backEndData.price.toString(),
    currency: {
      id: currency!.id,
      name: currency!.code,
    },
    priceDurationAmount: backEndData.priceDurationAmount?.toString(),
    priceDurationUnit: getDurationUnits("Course").find(
      (d) => d.id === backEndData.priceDurationUnit,
    )!,
    commissionAmount: backEndData.commissionAmount.toString(),
    commissionType: COMMISSION_TYPES.find(
      (c) => c.id === backEndData.commissionType,
    )!,
    residenceAmount: backEndData.residenceAmount?.toString(),
    homestayAmount: backEndData.homestayAmount?.toString(),
    insuranceAmount: backEndData.insuranceAmount?.toString(),
    mainOtherFees: addedOtherFees.splice(0, 2),
    addedOtherFees: addedOtherFees,
    hasPriceDiscount: backEndData.hasPriceDiscount,
    hasOtherFeesDiscount: backEndData.hasOtherFeesDiscount,
    priceDiscountType: COMMISSION_TYPES.find(
      (c) => c.id === backEndData.priceDiscountType,
    )!,
    priceDiscountAmount: backEndData.priceDiscountAmount?.toString(),
    otherFeesDiscountType: COMMISSION_TYPES.find(
      (c) => c.id === backEndData.otherFeesDiscountType,
    )!,
    otherFeesDiscountAmount: backEndData.otherFeesDiscountAmount?.toString(),
  };

  //-----------------Step3---------------------------
  const details = {};
  backEndData.details.forEach((detail) => {
    details[`type_${detail.type}`] = detail.content;
  });

  const step4: IStep4 = {
    details,
    detailFiles: backEndData.detailFiles!.map((file) => ({
      id: file.fileId,
      name: file.name!,
      size: file.size!,
      path: file.path!,
    })),
  };

  return {
    id: backEndData.id,
    schoolId,
    mode: "Edit",
    isInnerSubmission: false,
    step1,
    step2,
    step3,
    step4,
  };
}
